



































import {Vue, Component, Prop} from 'vue-property-decorator';
import {Util} from '@/utils';
import AppCenterService from "@service/app/app-center-service";

/**
 * 开发模式控制行为组
 *
 * @export
 * @class AppDebugActions
 * @extends {Vue}
 */
@Component({})
export default class AppChangePassword extends Vue {
  /**
   * 修改密码弹窗
   */
  public modalVisible: boolean = false;
  public isOldPassWord: boolean = true;
  public isPassWord: boolean = true;
  public isPassWordConfirm: boolean = true;
  private ssoCode: String | undefined;
  private loginName: String | undefined;
  // 是否允许关闭
  public canClose: boolean = true;
  public passwordForm = {
    oldPassWord:'',
    newPassWord: "",
    confirmPassword: ""
  }

  public checkPassWord(rule: any, value: any, callback: any) {
    let reg: any = /^[a-zA-Z]+$/
    let req_: any = /^[0-9]+$/
    if (value) {
      if (reg.test(value) || req_.test(value) || value.length < 8) {
        callback(new Error("密码过于简单！密码长度不能少于8位，不能全为数字或者字母"));
      } else {
        callback();
      }
    }
  }

  public passwordRule = {
    oldPassWord: [
      {required: true, message: '旧密码不能为空', trigger: 'blur'}
    ],
    newPassWord: [
      {required: true, message: '新密码不能为空', trigger: 'blur'},
      {validator: this.checkPassWord, trigger: "change"}
    ],
    confirmPassword: [
      {required: true, message: '确认密码不能为空', trigger: 'blur'},
      {validator: this.checkPassWord, trigger: "change"}
    ],
  }

  public oldPassowordClick(){
    this.isOldPassWord = !this.isOldPassWord
  }
  public passowordClick() {
    this.isPassWord = !this.isPassWord
  }

  public isPassWordConfirmClick() {
    this.isPassWordConfirm = !this.isPassWordConfirm;
  }

  public onVisibleChange() {
    const refs = (this.$refs) as any;
    refs.passwordFormRef.resetFields();
  }

  public changePassWordConfirm() {
    const refs = (this.$refs) as any;
    refs.passwordFormRef.validate((valid: boolean) => {
      if (valid) {
        // 验证两次输入的密码是否相同
        if (this.passwordForm.newPassWord != this.passwordForm.confirmPassword) {
          this.$Message.error('确认密码与新密码不一致，请检查后重新输入');
          return;
        }
        this.$emit('postMesToServicePhone',this.passwordForm)
      }
    })
  }

}
